module.exports = __webpack_public_path__ + "static/media/metamask.46fd2620.svg";